export default {

  get(env) {
    return window.localStorage.getItem(`moqo-api-token.${env}`)
  },

  set (env, value) {
    if (!value) {
      window.localStorage.removeItem(`moqo-api-token.${env}`)
    } else {
      window.localStorage.setItem(`moqo-api-token.${env}`, value)
    }
  },

  httpHeaders(env) {
    return {
        'Authorization': this.get(env)
    }
  }

}